import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  // type: {...config} 형식으로 저장됨
};

const reducers = {
  setConfig(state, action) {
    const allConfig = action.payload;
    for (let configName in allConfig) {
      state[configName] = allConfig[configName];
    }
  },
  updateMyConfig(state, action) {
    const { type, config } = action.payload;
    const previous = state[type];
    // ...undefined is OK
    state[type] = { ...previous, ...config };
  },
};

export const slice = createSlice({
  name: "config",
  initialState,
  reducers,
});

export const { reducer } = slice;
